"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Advisory() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="currentinventoryadvisory" data-nav="light" className="relative w-full bg-background text-foreground py-16 md:py-24 border-y border-border">
      {/* Anchor alias target for hero navigation */}
      <span id="inventory" className="sr-only absolute -top-16" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.45,
        ease: "easeOut"
      }} className="border-2 border-border bg-card text-card-foreground p-6 md:p-10 lg:p-12 shadow-md relative">
          {/* Industrial accent top bar */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-primary" />

          <div className="flex flex-col gap-8 md:gap-10">
            {/* Static inventory guidance block */}
            <div className="space-y-6 pt-4 border-t border-border">
              <div className="space-y-2">
                <h3 className="text-xl md:text-2xl font-default font-bold uppercase tracking-tight text-foreground">
                  Choose Your Mechanical Bull
                </h3>
                <p className="text-base text-muted-foreground max-w-3xl leading-relaxed">
                  Our inflatable mechanical bull systems use the same powered bulls available in our New and Used Bull collections. Choose the inventory that best matches your budget and requirements.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="border border-border bg-card rounded-none p-6 flex flex-col justify-between space-y-5">
                  <div className="space-y-2">
                    <h4 className="font-default font-bold text-lg md:text-xl uppercase tracking-tight text-foreground">
                      New Mechanical Bulls
                    </h4>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                      Browse new commercial mechanical bulls and available configurations.
                    </p>
                  </div>
                  <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-none font-mono text-xs uppercase tracking-wider font-semibold py-5">
                    <Link to="/NewMechanicalBullsPage" className="inline-flex items-center justify-center gap-2">
                      <span>Shop New Bulls</span>
                      <ArrowUpRight className="size-4" />
                    </Link>
                  </Button>
                </div>

                <div className="border border-border bg-card rounded-none p-6 flex flex-col justify-between space-y-5">
                  <div className="space-y-2">
                    <h4 className="font-default font-bold text-lg md:text-xl uppercase tracking-tight text-foreground">
                      Used Mechanical Bulls
                    </h4>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                      Browse pre-owned commercial mechanical bulls at lower purchase prices.
                    </p>
                  </div>
                  <Button asChild variant="outline" className="w-full border border-foreground/20 text-foreground bg-background hover:bg-accent hover:text-accent-foreground rounded-none font-mono text-xs uppercase tracking-wider font-semibold py-5">
                    <Link to="/UsedMechanicalBullsPage" className="inline-flex items-center justify-center gap-2">
                      <span>Shop Used Bulls</span>
                      <ArrowUpRight className="size-4" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}